import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { ProgramArticle } from "../../models/program-article";
import {
  ProgramArticleTranslationETTValue,
  ProgramArticlePictureETTValue,
} from "../../models/program-article-translation-value";

export const PROGRAM_ARTICLES_ACTIONS = {
  SET_PROGRAM_ARTICLES: "SET_PROGRAM_ARTICLES",
  SET_CURRENT_PROGRAM_ARTICLE: "SET_CURRENT_PROGRAM_ARTICLE",
  UPDATE_PROGRAM_ARTICLE: "UPDATE_PROGRAM_ARTICLE",
  UPDATE_PROGRAM_ARTICLES: "UPDATE_PROGRAM_ARTICLES",
  UPDATE_PROGRAM_ARTICLE_PICTURE: "UPDATE_PROGRAM_ARTICLE_PICTURE",
  SET_MULTILINGUAL_TRANSLATIONS: "SET_MULTILINGUAL_TRANSLATIONS",
  SET_MULTILINGUAL_PICTURES: "SET_MULTILINGUAL_PICTURES",
};

export interface ProgramArticlesStateInterface {
  programArticles: ProgramArticle[];
  currentProgramArticle: ProgramArticle;
}

@Injectable()
export class ProgramArticlesActions {
  constructor(private store: Store<ProgramArticlesStateInterface>) {}

  setProgramArticles(programArticles: ProgramArticle[]) {
    this.store.dispatch({
      type: PROGRAM_ARTICLES_ACTIONS.SET_PROGRAM_ARTICLES,
      payload: programArticles,
    });
  }

  setCurrentProgramArticle(programArticle: ProgramArticle) {
    this.store.dispatch({
      type: PROGRAM_ARTICLES_ACTIONS.SET_CURRENT_PROGRAM_ARTICLE,
      payload: programArticle,
    });
  }

  updateProgramArticle(programArticle: ProgramArticle) {
    this.store.dispatch({
      type: PROGRAM_ARTICLES_ACTIONS.UPDATE_PROGRAM_ARTICLE,
      payload: programArticle,
    });
  }

  updateProgramArticles(programArticles: ProgramArticle[]) {
    this.store.dispatch({
      type: PROGRAM_ARTICLES_ACTIONS.UPDATE_PROGRAM_ARTICLES,
      payload: programArticles,
    });
  }

  updateProgramArticlePicture(
    pictures: ProgramArticlePictureETTValue[],
    type: string
  ) {
    this.store.dispatch({
      type: PROGRAM_ARTICLES_ACTIONS.UPDATE_PROGRAM_ARTICLE_PICTURE,
      payload: { pictures: pictures, type: type },
    });
  }

  setMultilingualTranslations(
    translations: ProgramArticleTranslationETTValue[],
    destination: string
  ) {
    this.store.dispatch({
      type: PROGRAM_ARTICLES_ACTIONS.SET_MULTILINGUAL_TRANSLATIONS,
      payload: { translations: translations, destination: destination },
    });
  }

  setMultilingualPictures(
    pictures: ProgramArticlePictureETTValue[],
    destination: string
  ) {
    this.store.dispatch({
      type: PROGRAM_ARTICLES_ACTIONS.SET_MULTILINGUAL_PICTURES,
      payload: { pictures: pictures, destination: destination },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/store/actions/program-articles.actions.ts